import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsGY: CultureInfo = {
  name: 'es-GY',
  displayName: 'español (Guyana)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-GY',
  parent: CultureInfoEs
};
